"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadChemFactory = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Units_1 = require("../../Units");
var RadChemFactory = (function (_super) {
    __extends(RadChemFactory, _super);
    function RadChemFactory() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.RAD_CHEM_FACTORY,
            tags: [Tags_1.Tags.BUILDING],
            cost: 8,
            productionBox: Units_1.Units.of({ energy: -1 }),
            tr: { tr: 2 },
            metadata: {
                cardNumber: '205',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.minus().energy(1); }).br;
                    b.tr(2);
                }),
                description: 'Decrease your Energy production 1 step. Raise your TR 2 steps.',
            },
        }) || this;
    }
    RadChemFactory.prototype.canPlay = function (player) {
        return player.getProduction(Resources_1.Resources.ENERGY) >= 1;
    };
    RadChemFactory.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.ENERGY, -1);
        player.increaseTerraformRatingSteps(2);
        return undefined;
    };
    return RadChemFactory;
}(Card_1.Card));
exports.RadChemFactory = RadChemFactory;
